export const API = {
  auth: {
    login: '/v1/dashboard/login/',
    updateToken: '/v1/notifications/update_token/',
  },
  me: {
    profile: '/v1/users/profile/',
    courierMe: '/v1/couriers/couriers/me/',
  },
  vendors: {
    list: '/v1/users/vendors/vendors/',
    byId: (id) => `/v1/users/vendors/vendors/${id}/`,
    clients: '/v1/users/vendors/vendors/clients/',
    clientsSearch: (q) => `/v1/users/vendors/vendors/clients/?search=${q}`,
    createClient: '/v1/users/vendors/vendors/create_client/',
    markClientVerified: (id) => `/v1/users/vendors/vendors/clients/${id}/mark_verified/`,
    isRegionAvailable: '/v1/users/vendors/vendors/is_region_available/',
    isDistrictAvailable: '/v1/users/vendors/vendors/is_district_available/',
    stats: (id) => `/v1/users/vendors/vendors/${id}/stats/`,
    statsMe: '/v1/users/vendors/vendors/stats/',
    tippingSettings: (id) => `/v1/users/vendors/vendors/${id}/tipping_settings/`,
    totalOrderStats: (id) => `/v1/users/vendors/vendors/${id}/total_order_stats/`,
    totalOrderStatsMe: '/v1/users/vendors/vendors/total_order_stats/',
    addBottles: '/v1/users/vendors/vendors/add-bottles/',
    availablePlaces: '/v1/users/vendors/vendor-available-places/',
    availablePlaceById: (id) => `/v1/users/vendors/vendor-available-places/${id}/`,
    availablePlaceDistricts: (id) => `/v1/users/vendors/vendor-available-places/${id}/districts/`,
    requestToVendor: '/v1/users/vendors/request-to-vendor/',
    smsRecipientsCount: '/v1/users/vendors/vendors/sms_recipients_count/',
    sendSms: '/v1/users/vendors/vendors/send_sms/',
  },
  customers: {
    list: '/v1/users/customers/customers/',
    byId: (id) => `/v1/users/customers/customers/${id}/`,
  },
  couriers: {
    list: '/v1/couriers/couriers/',
    byId: (id) => `/v1/couriers/couriers/${id}/`,
    statisticsAll: '/v1/couriers/couriers/statistics/all',
  },
  orders: {
    list: '/v2/orders/orders/',
    byId: (id) => `/v2/orders/orders/${id}/`,
    acceptOrder: (id) => `/v1/orders/orders/${id}/accept_order/`,
    markDelivering: (id) => `/v1/orders/orders/${id}/mark_delivering/`,
    markDelivered: (id) => `/v2/orders/orders/${id}/mark_delivered/`,
    cancelOrder: (id) => `/v1/orders/orders/${id}/cancel_order/`,
    applications: '/v1/orders/applications/',
    applicationById: (id) => `/v1/orders/applications/${id}/`,
  },
  products: {
    list: '/v2/products/products/',
    byId: (id) => `/v2/products/products/${id}/`,
    categories: '/v2/products/categories/',
    allComments: '/v1/products/products/all-comments/',
    banners: '/v1/products/banners/',
    bannerById: (id) => `/v1/products/banners/${id}/`,
  },
  promotions: {
    list: '/v2/promotions/promotions/',
    byId: (id) => `/v2/promotions/promotions/${id}/`,
  },
  billing: {
    accounts: '/v1/billing/accounts/',
    accountsByClient: '/v1/billing/accounts/by_client/',
    transactions: (id) => `/v1/billing/accounts/${id}/transactions/`,
    closeDebt: (id) => `/v1/billing/accounts/${id}/close_debt/`,
    closeForClient: '/v1/billing/accounts/close_for_client/',
    bottleReturnHistory: (id) => `/v1/billing/accounts/${id}/bottle_return_history/`,
  },
  helpers: {
    regions: '/v1/helpers/regions/',
    districts: (regionId) => `/v1/helpers/regions/${regionId}/districts/`,
    geoSearch: '/v1/helpers/geo/search/',
    geoReverse: '/v1/helpers/geo/reverse/',
  },
  consultations: {
    list: '/v1/consultations/consultations/',
  },
};
